export const SectorSubjects = (
    <div className="flex flex-col gap-2">
        <div>
            This cluster has the same six elements as the Organizations cluster,
            but breaks down the last 12 months of communications by subjects
            lobbied on.
        </div>
    </div>
);
